import baseScmService from 'services/baseScmService';

const lessonService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    updateLesson: build.mutation({
      query: ({ academyTopicId, lesson, classTag }) => ({
        method: 'PUT',
        url: `lessons/${lesson.id}`,
        body: { lesson, class_tag: classTag },
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
    createLesson: build.mutation({
      query: ({ academyTopicId, lesson }) => ({
        method: 'POST',
        url: 'lessons/',
        body: { lesson: { ...lesson, academy_topic_id: academyTopicId } },
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
    deleteLesson: build.mutation({
      query: ({ academyTopicId, lessonId }) => ({
        method: 'DELETE',
        url: `lessons/${lessonId}`,
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateLessonMutation,
  useDeleteLessonMutation,
  useUpdateLessonMutation,
} = lessonService;

export default lessonService;
